// extracted by mini-css-extract-plugin
export default {"panel":"panel--vSYBk","mobile":"mobile--SBLtK"};